import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useContext } from 'preact/compat';
import { useFieldsWrapper } from '@genericBookings/context/FieldsWrapper';
import { useFormContext, } from 'react-hook-form';
import { useStepCompletion } from '@widgets/DayTickets/context/Steps';
import Styles from './styles';
function NoSessions({ noSessionsText, options }) {
    const { isBuilder } = useContext(options);
    const { setDatepickerOpen, setReservationFailed } = useFieldsWrapper();
    const { resetStepsCompleted } = useStepCompletion();
    const { setValue } = useFormContext();
    return (_jsxs(Styles.Wrapper, { children: [_jsx(Styles.Text, { children: noSessionsText }), _jsx(Styles.Link, { type: "button", onClick: () => {
                    if (!isBuilder) {
                        setDatepickerOpen(true);
                    }
                    else {
                        setValue('VisitDate', '');
                        resetStepsCompleted();
                        setReservationFailed(false);
                    }
                }, children: "Change Date" })] }));
}
export default NoSessions;
